import React, { useEffect } from 'react';
import { Navigate } from 'react-router';
import { useProfile } from '../hooks/UserHooks';
import { postLogout } from '../api/authApi';

const AuthProtected = (props: any) => {
    const { userProfile, loading } = useProfile();

    useEffect(() => {
        if (!userProfile && loading) {
            postLogout();
        }
    }, [userProfile, loading]);

    /*
      Navigate is un-auth access protected routes via url
      */

    if (!userProfile && loading) {
        return (
            <Navigate to={{ pathname: "/login" }}/>
        );
    }

    return <>{props.children}</>;
};


export default AuthProtected;